import React, { useEffect, useState, useRef } from "react";
import Menu from "../Menu";
import "../../App.css";
import HomeServices from "./HomeServices";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, Typography, Button, IconButton, useTheme, useMediaQuery } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import HomeTest from "./HomeTest";
import RequestCallback from "./RequestCallback";

// Custom Arrow Components
const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%", // Center vertically
        transform: "translateY(-50%)", // Adjust for perfect centering
        left: "20px", // Adjust spacing from the left
        zIndex: 3,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        color: "#fff",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <ArrowBackIosIcon />
    </IconButton>
  );
  
  const NextArrow = ({ onClick }: { onClick?: () => void }) => (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%", // Center vertically
        transform: "translateY(-50%)", // Adjust for perfect centering
        right: "20px", // Adjust spacing from the right
        zIndex: 3,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        color: "#fff",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <ArrowForwardIosIcon />
    </IconButton>
  );
  


  const slides = [
    {
      title: "CLAIM FROM IPEF",
      subtitle: "Recover What's Rightfully Yours",
      description: "Expert assistance in reclaiming unclaimed shares and dividends with complete transparency and care.",
      image: "/assets/service_01.jpg",
    },
    {
      title: "ROC SERVICES",
      subtitle: "Seamless Corporate Compliance",
      description: "Comprehensive ROC solutions including incorporation, filings, and regulatory support to keep your business compliant.",
      image: "/assets/service_02.jpg",
    },
  ];

const HomeHero: React.FC = () => {
  const contentContainerRef = useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true, // Enable custom arrows
    prevArrow: <PrevArrow />, // Custom previous arrow
    nextArrow: <NextArrow />, // Custom next arrow
  };

  useEffect(() => {
    const handleScroll = () => {
      if (contentContainerRef.current) {
        const contentRect = contentContainerRef.current.getBoundingClientRect();
        setIsSticky(contentRect.top <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="content-container" ref={contentContainerRef}>
      <Box
        sx={{
          width: "100%",
          height: {
            xs: "60vh", // Smaller height on mobile
            md: "80vh", // Full height on desktop
          },
          position: "relative",
          overflow: "hidden",
        }}>   
        <Menu isSticky={isSticky} />   
        <Slider {...sliderSettings}>
            {slides.map((slide, index) => (
            <Box
                key={index}
                sx={{
                width: "100%",
                height: {
                  xs: "60vh", // Smaller height on mobile
                  md: "80vh", // Full height on desktop
                },
                background: `
                linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), 
                url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                position: "relative",
                }}
            >
            
                <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "#fff",
                    textAlign: "center",
                }}
                >
                <Typography 
                  variant={isMobile ? "h4" : "h3"}
                  sx={{
                    fontSize: {
                      xs: "1.8rem", // Smaller on mobile
                      md: "3rem", // Larger on desktop
                    },
                    fontWeight: "bold",
                    marginBottom: 2,
                  }}
                >
                  {slide.title}
                </Typography>
                <Typography 
                  variant={isMobile ? "body1" : "subtitle1"}
                  sx={{
                    fontSize: {
                      xs: "1rem", // Smaller on mobile
                      md: "1.25rem", // Larger on desktop
                    },
                    marginBottom: 2,
                  }}
                >
                  {slide.subtitle}
                </Typography>
                <Typography 
                  variant="body1"
                  sx={{
                    fontSize: {
                      xs: "0.9rem", // Smaller on mobile
                      md: "1rem", // Normal on desktop
                    },
                    maxWidth: {
                      xs: "90%", // Constrain width on mobile
                      md: "70%", // Constrain width on desktop
                    },
                    margin: "0 auto",
                    lineHeight: 1.5,
                  }}
                >
                  {slide.description}
                </Typography>
                </Box>
            </Box>
            ))}
        </Slider>
          {/* Static Content at Bottom */}
          <Box
            sx={{
                position: "absolute",
                bottom: {
                  xs: "10px", // Higher position on mobile to avoid overlap
                  md: 0, // Bottom on desktop
                },
                left: 0,
                width: "100%",
                padding: {
                  xs: "8px 4px", // Much smaller padding on mobile
                  md: "20px", // Normal padding on desktop
                },
                zIndex: 2,
                textAlign: "center",
                backgroundColor: {
                  xs: "rgba(0, 0, 0, 0.3)", // Semi-transparent background on mobile
                  md: "transparent", // No background on desktop
                },
                borderRadius: {
                  xs: "8px 8px 0 0", // Rounded top corners on mobile
                  md: 0, // No border radius on desktop
                },
            }}
            >
            {/* Text */}
            <Typography
                variant="h6"
                sx={{
                color: "#FFFFFF",
                fontFamily: "'Poppins', sans-serif",
                fontSize: {
                  xs: "11px", // Much smaller on mobile
                  md: "16px", // Normal on desktop
                },
                fontWeight: "normal",
                marginBottom: {
                  xs: "8px", // Much smaller margin on mobile
                  md: "20px", // Normal margin on desktop
                },
                maxWidth: {
                  xs: "98%", // Almost full width on mobile
                  md: "80%", // Constrain width on desktop
                },
                margin: {
                  xs: "0 auto 8px auto", // Center and add small margin on mobile
                  md: "0 auto 20px auto", // Center and add margin on desktop
                },
                lineHeight: {
                  xs: 1.2, // Tighter line height on mobile
                  md: 1.5, // Normal line height on desktop
                },
                }}
            >
                GetMyShare has a dedicated team of IEPF Claim Experts including qualified professionals - CA, CS, Lawyers.
            </Typography>

            {/* CTA Button */}
            <Button
                variant="contained"
                sx={{
                backgroundColor: "#F57C00",
                color: "#FFFFFF",
                fontFamily: "'Poppins', sans-serif",
                fontWeight: "bold",
                fontSize: {
                  xs: "10px", // Much smaller on mobile
                  md: "14px", // Normal on desktop
                },
                textTransform: "none",
                marginBottom: {
                  xs: "8px", // Much smaller margin on mobile
                  md: "20px", // Normal margin on desktop
                },
                padding: {
                  xs: "6px 12px", // Much smaller padding on mobile
                  md: "10px 20px", // Normal padding on desktop
                },
                "&:hover": {
                    backgroundColor: "#D35400",
                },
                }}
                onClick={() => window.open("/ipef-search", "_blank")} // Opens a new page
            >
                Get Free IEPF Search
            </Button>
          </Box>
        </Box>
     <HomeServices></HomeServices>
     <HomeTest></HomeTest>
     <RequestCallback></RequestCallback>
    </div>
  );
};

export default HomeHero;